import axios from 'axios';
import { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import core from '../../core';
import "./Vehicles.css"
import { Pagination, Stack } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { Search, ThreeDotsVertical } from 'react-bootstrap-icons';
import OutsideClickHandler from 'react-outside-click-handler';
import { Button, Modal } from 'react-bootstrap';
import CreateVehicle from './CreateVehicle';
import { notificationActions } from '../../data/notification';
import UploadImages from './UploadImages';
import {Link} from "react-router-dom"
import AddReceiver from './AddReceiver';
import { getReceiverStatus, formatTimeLeft } from '../../utils/receiver';
import useViewMode from '../../hooks/useViewMode';
import ViewToggle from '../../components/DataView/ViewToggle';
import DataCards from '../../components/DataView/DataCards';
import useT from '../../i18n/useT';

const Vehicles = () => {
    const [filter, setFilter] = useState({keyword: "", start_date: "", status: "", paid: "", auction: "", end_date: "", limit: 10, page: 1, line: "", asc: "desc", sort_by: "id"})
    const [cars, setCars] = useState([]);
    const [paginator, setPaginator] = useState({from: 0, to: 0, total: 0, pages: 1});
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const lang = useSelector((state) => state.user.language);
    const [keyword, setKeyword] = useState("");
    const [showDateSelector, setShowDateSelector] = useState(false);
    const [dates, setDates] = useState({start_date: "", end_date: ""});
    const [showFilters, setShowFilters] = useState(false);
    const [formData, setFormData] = useState({dealer_id: "", pending: false, receiver_fullname: "", receiver_identity_number: "", mark: "", model: "", year: "", vin: "", lot_number: "", 
        auction: "", us_state: "", destination_port: "", us_port: "", is_sublot: false, is_funded: false, is_insured: false, doc_type: "", container_cost: "", landing_cost: "", vehicle_price: "", total_price: "", 
        buyer_number: "", has_key: false, is_hybrid: false, vehicle_type: "", purchase_date: "", user: "", profile_image_url: null, car_additional_amount: 0, transportation_additional_amount: 0, insuranse_type: "GPI"});
    const [formLoader, setFormLoader] = useState(false);
    const [showCreateVehicleModal, setShowCreateVehicleModal] = useState(false);
    const [actionType, setActionType] = useState(false);
    const [step, setStep] = useState(1);
    const [actionsId, setActionsId] = useState("");
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [showUploadImages, setShowUploadImages] = useState(false);
    const [handler, setHandler] = useState({name: "", title: ""});
    const [carInfo, setCarInfo] = useState({});
    const [addNoteModal, setAddNoteModal] = useState(false);
    const [updates, setUpdates] = useState(0);
    const [showAddReceiver, setShowAddReceiver] = useState(false);
    const {view, setView, isMobile} = useViewMode("vehicles-view");
    const t = useT();

    const rowStatus = (vehicle) => {
        if (vehicle.is_green == 1) return {label: t("vehicles.green"), color: "#28a745"};
        if (vehicle.current_status == "arrived" && vehicle.debt_amount > 0 && vehicle.is_green == 0) return {label: t("vehicles.debt"), color: "#dc3545"};
        return null;
    };

    // Generate (or reuse) a shareable invoice and open its printable page.
    const openInvoice = (vehicleId, type) => {
        axios.post(`/api/vehicle/${vehicleId}/invoice`, { type })
            .then((res) => {
                if (res.data && res.data.url) window.open(res.data.url, "_blank");
            })
            .catch((err) => {
                const msg = err.response && err.response.data && err.response.data.message ? err.response.data.message.en : "Error";
                dispatch(notificationActions.changeNotification({ show: true, text: msg, type: "error-notification" }));
                setTimeout(() => dispatch(notificationActions.changeNotification({ show: false, text: "", type: "" })), 4000);
            });
    };

    const rowActions = (vehicle) => (
        <div className='table-actions-block'>
            <ThreeDotsVertical height={"19px"} onClick={() => setActionsId(vehicle.id)} style={{cursor: "pointer"}}/>
            {actionsId === vehicle.id && <OutsideClickHandler onOutsideClick={() => setActionsId("")}>
                <div className='table-actions-dropdown'>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setStep(1)
                        setActionType("edit");
                        setFormData({dealer_id: vehicle.dealer_id, pending: vehicle.pending, user: vehicle.buyer, receiver_fullname: vehicle.receiver_fullname, receiver_identity_number: vehicle.receiver_identity_number,
                            mark: vehicle.mark, model: vehicle.model, year: vehicle.year, vin: vehicle.vin, lot_number: vehicle.lot_number, auction: vehicle.auction,
                            us_state: vehicle.us_state, destination_port: vehicle.destination_port, us_port: vehicle.us_port, is_sublot: vehicle.is_sublot, is_funded: vehicle.is_funded,
                            is_insured: vehicle.is_insured, create_date: vehicle.create_date, doc_type: vehicle.doc_type, title_received_date: vehicle.title_received_date ? core.formdatDate(vehicle.title_received_date, "yyyy-mm-dd") : "", container_cost: vehicle.container_cost, landing_cost: vehicle.landing_cost, vehicle_price: vehicle.vehicle_price,
                            total_price: vehicle.total_price, buyer_number: vehicle.buyer_number, has_key: vehicle.has_key, is_hybrid: vehicle.is_hybrid, vehicle_type: vehicle.vehicle_type,
                            purchase_date: core.formdatDate(vehicle.purchase_date, "yyyy-mm-dd"), id: vehicle.id, car_additional_amount: vehicle.car_additional_amount, transportation_additional_amount: vehicle.transportation_additional_amount, insuranse_type: vehicle.insuranse_type});
                        setShowCreateVehicleModal(true);
                    }}>{t("common.edit")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setFormData((prev) => ({...prev, id: vehicle.id}));
                        setShowConfirmationModal(true);
                        setHandler({title: t("vehicles.confirmRemoveCar"), name: "removeCar"});
                    }}>{t("common.delete")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setShowAddReceiver(true);
                        setCarInfo(vehicle)
                    }}>{t("vehicles.addReceiver")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setFormData((prev) => ({...prev, id: vehicle.id}));
                        setShowConfirmationModal(true);
                        setHandler({title: t("vehicles.confirmMarkGreen"), name: "markCarAsGreen"});
                    }}>{t("vehicles.markAsGreen")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setFormData((prev) => ({...prev, id: vehicle.id}));
                        setShowUploadImages(true);
                    }}>{t("vehicles.uploadImages")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setShowConfirmationModal(true);
                        setHandler({title: t("vehicles.confirmContainerLoaded"), name: "containerLoaded"});
                        setCarInfo({id: vehicle.id, vin: vehicle.vin})
                    }}>{t("vehicles.containerLoaded")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setAddNoteModal(true);
                        setCarInfo({id: vehicle.id, vin: vehicle.vin})
                    }}>{t("vehicles.addNote")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        openInvoice(vehicle.id, "car");
                    }}>{t("vehicles.carInvoice")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        openInvoice(vehicle.id, "transportation");
                    }}>{t("vehicles.transportationInvoice")}</div>
                </div>
            </OutsideClickHandler>}
        </div>
    );

    // Receiver cell: show the name if set, otherwise a reminder badge with a
    // countdown (or "expired" once the 2-day dealer window has closed).
    const receiverCell = (v) => {
        if (v.receiver_fullname) return v.receiver_fullname;
        const status = getReceiverStatus(v);
        if (!status.required) return "—";
        if (status.locked) {
            return <span style={{background: "#dc3545", color: "white", padding: "2px 9px", borderRadius: "12px", fontSize: "11px", whiteSpace: "nowrap"}}>{t("vehicles.receiverExpired")}</span>;
        }
        return <span style={{background: "#ff9f0a", color: "white", padding: "2px 9px", borderRadius: "12px", fontSize: "11px", whiteSpace: "nowrap"}}>{t("vehicles.receiverRequired")} · {formatTimeLeft(status.msLeft, t)}</span>;
    };

    // Title warning badge: red when loaded to a container without a title,
    // amber when the title simply hasn't arrived yet. Null once received.
    const titleBadge = (v) => {
        if (v.title_warning) {
            return <span title={t("vehicles.titleWarning")} style={{background: "#dc3545", color: "white", padding: "2px 9px", borderRadius: "12px", fontSize: "11px", whiteSpace: "nowrap"}}>⚠ {t("vehicles.titleMissing")}</span>;
        }
        if (v.title_missing) {
            return <span title={t("vehicles.titleMissing")} style={{background: "#6c757d", color: "white", padding: "2px 9px", borderRadius: "12px", fontSize: "11px", whiteSpace: "nowrap"}}>{t("vehicles.titleMissing")}</span>;
        }
        return null;
    };

    const cardFields = [
        {label: t("vehicles.image"), value: (v) => <Link to={`/vehicle-details/${v.id}`}><img src={v.profile_image_url} alt="car" style={{height: "45px"}} /></Link>},
        {label: t("vehicles.dealer"), value: (v) => v.buyer},
        {label: t("vehicles.purchaseDate"), value: (v) => v.purchase_date != null ? core.formdatDate(v.purchase_date, "yyyy-mm-dd") : t("table.notDefined")},
        {label: t("vehicles.receiver"), value: (v) => receiverCell(v)},
        {label: t("vehicles.personalNumber"), value: (v) => v.receiver_identity_number},
        {label: t("vehicles.phone"), value: (v) => v.receiver_phone},
        {label: t("vehicles.container"), value: (v) => v.container_number},
        {label: t("vehicles.booking"), value: (v) => v.booking},
        {label: t("vehicles.line"), value: (v) => v.line},
        {label: t("vehicles.auction"), value: (v) => v.auction},
        {label: t("vehicles.state"), value: (v) => v.us_state},
        {label: t("vehicles.paid"), value: (v) => `$${v.payed_amount}`},
        {label: t("vehicles.transportation"), value: (v) => `$${v.total_price}`},
        {label: t("vehicles.carAmount"), value: (v) => `$${v.vehicle_price}`},
        {label: t("vehicles.debt"), value: (v) => `$${v.debt_amount}`},
        {label: t("vehicles.status"), value: (v) => {
            const status = rowStatus(v);
            return <span style={{display: "inline-flex", gap: "6px", flexWrap: "wrap", alignItems: "center"}}>
                {status ? <span style={{background: status.color, color: "white", padding: "2px 10px", borderRadius: "12px", fontSize: "12px"}}>{status.label}</span> : "—"}
                {titleBadge(v)}
            </span>;
        }},
    ];

    const handlers = {
        createVehicle(e){
            e.preventDefault();
            setFormLoader(true);
            const carForm = new FormData();
            Object.entries(formData).forEach(([key, value]) => key != "profile_image_url" ? carForm.append(key, value) : carForm.append(key, value[0]));
            axios.post('/api/cars', carForm)
                .then((res) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setStep(2);
                })
                .catch((err) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        modifyVehicle(e){
            e.preventDefault();
            setFormLoader(true);
            axios.put(`/api/cars/${formData.id}`, formData)
                .then((res) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setShowCreateVehicleModal(false);
                    setUpdates((prev) => prev + 1);
                })
                .catch((err) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        containerLoaded(){
            const form = {
                container_loading_date: new Date(),
                estimated_receive_date: carInfo.estimated_receive_date,
                vin: carInfo.vin
            }
            setFormLoader(true);
            axios.put(`/api/cars/${carInfo.id}/container-loading`, form)
                .then((res) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
                .catch((err) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        addNote(){
            setFormLoader(true);
            axios.post(`/api/car/${carInfo.id}/note`, {message: carInfo.message, vin: carInfo.vin})
                .then((res) => {
                    setAddNoteModal(false);
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
                .catch((err) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        removeCar(){
            setFormLoader(true);
            axios.delete(`/api/vehicle/${formData.id}`)
                .then((res) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setUpdates((prev) => prev + 1);
                    setShowConfirmationModal(false);
                })
                .catch((err) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        markCarAsGreen(){
            setFormLoader(true);
            axios.post(`/api/cars/${formData.id}/mark-as-green`)
                .then((res) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setUpdates((prev) => prev + 1);
                    setShowConfirmationModal(false);
                })
                .catch((err) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        }
    }

    useEffect(() => {
        setLoading(true);
        axios.get(`/api/vehicles?limit=${filter.limit}&page=${filter.page}&auction=${filter.auction}&keyword=${filter.keyword}&asc=${filter.asc}&start_date=${filter.start_date}&end_date=${filter.end_date}&sort_by=${filter.sort_by}&line=${filter.line}&status=${filter.status}&paid=${filter.paid}`)
            .then((res) => {
                setLoading(false);
                setCars(res.data.data);
                const fromItems = ((filter.page - 1) * filter.limit) + 1;
                const toItems = res.data.total < filter.page * filter.limit ? res.data.total :  filter.page * filter.limit;
                const pagesCount = res.data.total % filter.limit === 0 ? res.data.total / filter.limit : parseInt((res.data.total / filter.limit) + 1);
                setPaginator({from: fromItems, to: toItems, total: res.data.total, pages: pagesCount});
            })
            .catch((err) => {

            })
    }, [filter, step, updates]);

    return(
        <div className="page-content-main-container">
            <h2 className="page-title">{t("vehicles.title")}</h2>
            <div className="table-filter-container">
                <div className='data-table-filteres'>
                    <Button onClick={() => setShowFilters(true)} variant='primary' style={{marginRight: "15px", color: "white"}}>{t("common.filters")}</Button>
                    {showFilters && <OutsideClickHandler onOutsideClick={() => setShowFilters(false)}>
                        <div className='data-table-filters-dropdown'>
                            <div className='filter-selects'>
                                <select className='form-control' value={filter.sort_by} onChange={(e) => setFilter((prev) => ({...prev, sort_by: e.target.value}))}>
                                    <option value={"id"}>{t("common.sortBy")}</option>
                                    <option value={"container_loaded_date"}>{t("vehicles.sortContainerLoaded")}</option>
                                    <option value={"container_receive_date"}>{t("vehicles.sortContainerReceive")}</option>
                                    <option value={"est_opening_date"}>{t("vehicles.sortEstOpening")}</option>
                                    <option value={"open_date"}>{t("vehicles.sortOpenDate")}</option>
                                </select>
                            </div>
                            <div className='filter-selects'>
                                <select className='form-control' value={filter.asc} onChange={(e) => setFilter((prev) => ({...prev, asc: e.target.value}))}>
                                    <option value={""}>{t("vehicles.sortDesc")}</option>
                                    <option value={""}>{t("vehicles.oldToNew")}</option>
                                    <option value={"desc"}>{t("vehicles.newToOld")}</option>
                                </select>
                            </div>
                            <div className='filter-selects'>
                                <select className='form-control' onChange={(e) => setFilter((prev) => ({...prev, line: e.target.value}))}>
                                    <option value={""}>{t("vehicles.port")}</option>
                                    <option value={"Port 1"}>{t("vehicles.portNumber1")}</option>
                                    <option value={"Port 2"}>{t("vehicles.portNumber2")}</option>
                                    <option value={"Port 3"}>{t("vehicles.portNumber3")}</option>
                                </select>
                            </div>
                            <div className='filter-selects'>
                                <select className='form-control' onChange={(e) => setFilter((prev) => ({...prev, line: e.target.value}))}>
                                    <option value={""}>{t("vehicles.selectLine")}</option>
                                    <option value={"MSC"}>MSC</option>
                                    <option value={"Maersk"}>Maersk</option>
                                    <option value={"CMA CGM"}>CMA CGM</option>
                                    <option value={"Happag lloyd"}>Happag lloyd</option>
                                    <option value={"Cosco"}>Cosco</option>
                                    <option value={"Zim"}>Zim</option>
                                    <option value={"One Line"}>One Line</option>
                                </select>
                            </div>
                            <div className='date-selector-dropdown-container'>
                                <div className='date-selector-button' onClick={() => setShowDateSelector(!showDateSelector)}>{t("common.selectDate")}</div>
                                {showDateSelector && <OutsideClickHandler onOutsideClick={() => setShowDateSelector(false)}>
                                    <div className='date-selector-dropdown'>
                                        <div className='date-selector' style={{marginTop: "0px"}}>
                                            <span>{t("common.startDate")}</span>
                                            <input value={dates.start_date} type='date' onChange={(e) => setDates((prev) => ({...prev, start_date: e.target.value}))} className='form-control'/>
                                        </div>
                                        <div className='date-selector'>
                                            <span>{t("common.endDate")}</span>
                                            <input value={dates.end_date} type='date' className='form-control' onChange={(e) => setDates((prev) => ({...prev, end_date: e.target.value}))}/>
                                        </div>
                                        <Button onClick={() => setFilter((prev) => ({...prev, start_date: dates.start_date, end_date: dates.end_date}))} style={{width: "200px", marginTop: "15px"}}>{t("common.confirmDate")}</Button>
                                        <Button variant='danger' onClick={() => {
                                            setFilter((prev) => ({...prev, start_date: "", end_date: ""}));
                                            setDates({start_date: "", end_date: ''});
                                        }} style={{width: "200px", marginTop: "15px"}}>{t("common.clearDate")}</Button>
                                    </div>
                                </OutsideClickHandler>}
                            </div>
                        </div>    
                    </OutsideClickHandler>}
                </div>
                <ViewToggle view={view} setView={setView} isMobile={isMobile} />
                <button className='btn btn-primary' style={{marginRight: "15px", marginLeft: "15px"}} onClick={() => {
                    const qs = `keyword=${encodeURIComponent(filter.keyword)}&start_date=${filter.start_date}&end_date=${filter.end_date}&status=${filter.status}&line=${filter.line}&paid=${filter.paid}&auction=${filter.auction}`;
                    window.open(`/api/vehicles/export?${qs}`, "_blank");
                }}>{t("common.export")}</button>
                <button onClick={() => {
                    setShowCreateVehicleModal(true);
                    setActionType("add");
                    setFormData({dealer_id: "", receiver_fullname: "", pending: false, receiver_identity_number: "", mark: "", model: "", year: "", vin: "", lot_number: "", 
                        auction: "", us_state: "", destination_port: "", us_port: "", is_sublot: false, is_funded: false, is_insured: false, doc_type: "", container_cost: "", landing_cost: "", vehicle_price: "", total_price: "", 
                        buyer_number: "", has_key: true, is_hybrid: false, vehicle_type: "", purchase_date: "", car_additional_amount: 0, transportation_additional_amount: 0, insuranse_type: "GPI"});
                }} className='btn btn-primary' style={{marginRight: "15px"}}>{t("common.addNew")}</button>
                <div className='search-by-keyword' style={{marginRight: "0"}}>
                    <input placeholder={t("common.search")} type='text' onKeyDown={(e) => {
                        if(e.keyCode === 13){
                            setFilter((prev) => ({...prev, keyword: keyword}));
                        }
                    }} value={keyword} className='form-control' onChange={(e) => setKeyword(e.target.value)} />
                    <button onClick={() => setFilter((prev) => ({...prev, keyword: keyword}))}><Search /></button>
                </div>
            </div>
            {view === "table" ? (
            <Table responsive>
                <thead>
                    <tr>
                        <th>{t("vehicles.image")}</th>
                        <th>{t("vehicles.dealer")}</th>
                        <th>{t("vehicles.purchaseDate")}</th>
                        <th>{t("vehicles.vehicleName")}</th>
                        <th>VIN</th>
                        <th>{t("vehicles.receiver")}</th>
                        <th>{t("vehicles.personalNumber")}</th>
                        <th>{t("vehicles.phone")}</th>
                        <th>{t("vehicles.container")}</th>
                        <th>{t("vehicles.booking")}</th>
                        <th>{t("vehicles.line")}</th>
                        <th>{t("vehicles.auction")}</th>
                        <th>{t("vehicles.state")}</th>
                        <th>{t("vehicles.paid")}</th>
                        <th>{t("vehicles.transportation")}</th>
                        <th>{t("vehicles.carAmount")}</th>
                        <th>{t("vehicles.debt")}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading && <tr><td colSpan={17}><div style={{display: "flex", justifyContent: "center", alignItems: "center"}}><div className="loader" role=""></div></div></td></tr>
                    }
                    {
                        (cars.length > 0 && !loading) && cars.map((vehicle) => {
                            return(
                                <tr key={vehicle.id} className={`${vehicle.current_status == "arrived" && vehicle.debt_amount > 0 && vehicle.is_green == 0 ? "red-row" : ""} ${vehicle.is_green == 1 ? "green-row" : ""}`}>
                                    <td><Link to={`/vehicle-details/${vehicle.id}`}><img src={vehicle.profile_image_url} alt="car" style={{height: "45px"}} /></Link></td>
                                    <td>{vehicle.buyer}</td>
                                    <td>{vehicle.purchase_date != null ? core.formdatDate(vehicle.purchase_date, "yyyy-mm-dd") : t("table.notDefined")}</td>
                                    <td>{vehicle.mark} {vehicle.model} {vehicle.year} {titleBadge(vehicle) && <div style={{marginTop: "4px"}}>{titleBadge(vehicle)}</div>}</td>
                                    <td>{vehicle.vin}</td>
                                    <td>{receiverCell(vehicle)}</td>
                                    <td>{vehicle.receiver_identity_number}</td>
                                    <td>{vehicle.receiver_phone}</td>
                                    <td>{vehicle.container_number}</td>
                                    <td>{vehicle.booking}</td>
                                    <td>{vehicle.line}</td>
                                    <td>{vehicle.auction}</td>
                                    <td>{vehicle.us_state}</td>
                                    <td>${vehicle.payed_amount}</td>
                                    <td>${vehicle.total_price}</td>
                                    <td>${vehicle.vehicle_price}</td>
                                    <td>${vehicle.debt_amount}</td>
                                    <td>{rowActions(vehicle)}</td>
                                </tr>
                            )
                        })
                    }
                    {
                        (!loading && cars.length === 0) && <tr><td colSpan={17} style={{textAlign: "center"}}>{t("table.notFound")}</td></tr>
                    }
                </tbody>
            </Table>
            ) : (
                <DataCards layout={view}
                    items={loading ? [] : cars}
                    loading={loading}
                    getKey={(v) => v.id}
                    renderTitle={(v) => <Link to={`/vehicle-details/${v.id}`}>{v.mark} {v.model} {v.year}</Link>}
                    renderSubtitle={(v) => v.vin}
                    fields={cardFields}
                    renderActions={(v) => rowActions(v)}
                />
            )}
            <div className="pagination-container">
                <div className="paginatior-left-size">
                    <p className="showing-items-text">{t("table.showing")} {paginator.from} {t("table.of")} {paginator.to}</p>
                    <span style={{margin: "0 12px"}}>{t("table.total")}: {paginator.total}</span>
                    <span>{t("table.show")}:</span>
                    <select value={filter.limit} onChange={(e) => setFilter((prev) => ({...prev, limit: e.target.value}))} className="form-control" style={{width: "50px"}}>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={50}>50</option>
                    </select>
                </div>
                <Stack spacing={2}>
                    <Pagination count={paginator.pages} page={filter.page} onChange={(value, p) => setFilter((prev)=>({...prev, page: p}))} />
                </Stack>
            </div>
            <CreateVehicle setStep={setStep} setLoading={setFormLoader} car_id={cars[0] ? cars[0].id : 1} formData={formData} step={step} setFormData={setFormData} loading={formLoader} show={showCreateVehicleModal} setShow={setShowCreateVehicleModal} action={actionType} submit={actionType == "add" ? handlers.createVehicle : handlers.modifyVehicle} attachImages={handlers.attachImages} />
            <UploadImages show={showUploadImages} setShow={setShowUploadImages} id={formData.id} />
            <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)} >
                <Modal.Header closeButton><h3>{handler.title}</h3></Modal.Header>
                <Modal.Body>
                    <p>{t("vehicles.confirmPrompt")} {handler.title}?</p>
                    {handler.name == "containerLoaded" && <>
                        <label>{t("vehicles.estimatedReceiveDate")}</label>
                        <input className='form-control' type='date' onChange={(e) => setCarInfo((prev) => ({...prev, estimated_receive_date: e.target.value}))}/>
                    </>}
                </Modal.Body>
                <Modal.Footer>
                    <Button type='button' onClick={handlers[handler.name]} variant={formLoader ? 'secondary' : 'primary'} disabled={formLoader}>{formLoader ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : t("common.yes")}</Button>
                    <Button type='button' onClick={() => setShowConfirmationModal(false)} variant='danger'>{t("common.no")}</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={addNoteModal} onHide={() => setAddNoteModal(false)} >
                <Modal.Header closeButton><h3>{t("vehicles.addNote")}</h3></Modal.Header>
                <Modal.Body>
                    <textarea style={{width: "100%", height: "100px", outline: "none", borderRadius: "12px", padding: "10px", order: "1px solid gray"}} onChange={(e) => setCarInfo((prev) => ({...prev, message: e.target.value}))} />
                </Modal.Body>
                <Modal.Footer>
                    <Button type='button' onClick={handlers.addNote} variant={formLoader ? 'secondary' : 'primary'} disabled={formLoader}>{formLoader ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : t("common.save")}</Button>
                    <Button type='button' onClick={() => setAddNoteModal(false)} variant='danger'>{t("common.no")}</Button>
                </Modal.Footer>
            </Modal>
            <AddReceiver show={showAddReceiver} setHide={setShowAddReceiver} vehicle={carInfo} onSaved={() => setUpdates((prev) => prev + 1)} />
        </div>
    )
}

export default Vehicles